import a from "react";
import { getIconColor as i } from "./iconfont.es5470.js";
import x from "./iconfont.es5471.js";
const d = {
  display: "block"
}, f = ({ size: t = 16, useVw: c, useRem: n, color: o, withColor: l, removeClassName: e, disableSSR: m, style: r, ...p }) => {
  const h = r ? { ...d, ...r } : d;
  return /* @__PURE__ */ a.createElement(x, { disableSSR: m }, /* @__PURE__ */ a.createElement("svg", { "data-icon-id": "24px-tuichu", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 24 24", width: c ? ((t || 0) / 375 * 100).toFixed(5) + "vw" : t + (n ? "rem" : "px"), height: c ? ((t || 0) / 375 * 100).toFixed(5) + "vw" : t + (n ? "rem" : "px"), className: e ? "" : "iconpark-icon", style: h, fill: "none", ...p }, /* @__PURE__ */ a.createElement(
    "g",
    {
      className: e ? "" : "24px-éåº"
    },
    /* @__PURE__ */ a.createElement(
      "g",
      {
        className: e ? "" : "normal",
        fill: l ? i(o, 0, "#262933") : "#262933",
        datafollowfill: l ? i(o, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M6.036 2.877a3.911 3.911 0 0 0-3.911 3.911V17.16a3.911 3.911 0 0 0 3.911 3.911h7.902a2.874 2.874 0 0 0 2.874-2.874V17.16a.8.8 0 1 0-1.6 0v1.037c0 .704-.57 1.274-1.274 1.274H6.036a2.311 2.311 0 0 1-2.311-2.311V6.788a2.311 2.311 0 0 1 2.311-2.311h7.902c.704 0 1.274.57 1.274 1.274v1.037a.8.8 0 0 0 1.6 0V5.751a2.874 2.874 0 0 0-2.874-2.874H6.036Z"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M17.39 15.65a.8.8 0 0 0 1.131 0l3.12-3.119a.8.8 0 0 0 0-1.131l-3.112-3.112a.8.8 0 0 0-1.131 1.132l1.746 1.746h-8.44a.8.8 0 0 0 0 1.6h8.439L17.39 14.52a.8.8 0 0 0 0 1.13Z"
        }
      )
    )
  )));
}, s = f;
export {
  s as default
};
